// Figma: the "Success Illustration + Content Area + Action Box" template shared by
// login-magic-link-sent / login-resend-confirmation / signup-request-submitted /
// login-link-expired / login-link-already-used (e.g. nodes 18050:550, 18050:604,
// 18050:579, 18050:634, 18050:665). One reusable shell, configured per state by the caller.
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Stack, Typography} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import AuthCard from './AuthCard';
import AuthLogo from './AuthLogo';
import {tokens} from '../../../themes/ThemeCustomization';
import dividerLine from '../../../assets/auth/divider-line.svg';

const StatusCard = ({
    icon,
    iconBackground,
    title,
    description,
    primaryAction,
    secondaryAction,
    caption,
    showDivider = Boolean(caption)
}) => (
    <AuthCard gap="32px">
        <Stack alignItems="center" spacing={4} sx={{width: '100%'}}>
            <AuthLogo />
            <Box
                sx={{
                    width: 64,
                    height: 64,
                    borderRadius: tokens.radius.badge,
                    backgroundColor: iconBackground,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Box component="img" src={icon} alt="" sx={{width: 32, height: 32}} />
            </Box>
            <Stack spacing={1} textAlign="center" sx={{width: '100%'}}>
                <Typography variant="h4">{title}</Typography>
                <Typography variant="body2" color="text.secondary">
                    {description}
                </Typography>
            </Stack>
            <Stack alignItems="center" spacing={3} sx={{width: '100%'}}>
                <Stack alignItems="center" spacing={2} sx={{width: '100%'}}>
                    {primaryAction && (
                        <LoadingButton
                            fullWidth
                            variant="contained"
                            disabled={primaryAction.disabled}
                            loading={primaryAction.loading}
                            onClick={primaryAction.onClick}
                        >
                            {primaryAction.label}
                        </LoadingButton>
                    )}
                    {secondaryAction && (
                        <Typography
                            variant="body2"
                            fontWeight={500}
                            color="text.secondary"
                            onClick={secondaryAction.onClick}
                            sx={{cursor: 'pointer'}}
                        >
                            {secondaryAction.label}
                        </Typography>
                    )}
                </Stack>
                {showDivider && <Box component="img" src={dividerLine} alt="" sx={{width: '100%', height: '1px'}} />}
                {caption && (
                    <Typography variant="caption" color="text.secondary">
                        {caption}
                    </Typography>
                )}
            </Stack>
        </Stack>
    </AuthCard>
);

StatusCard.propTypes = {
    icon: PropTypes.string.isRequired,
    iconBackground: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired,
    primaryAction: PropTypes.shape({
        label: PropTypes.string,
        onClick: PropTypes.func,
        loading: PropTypes.bool,
        disabled: PropTypes.bool
    }),
    secondaryAction: PropTypes.shape({
        label: PropTypes.string,
        onClick: PropTypes.func
    }),
    caption: PropTypes.node,
    showDivider: PropTypes.bool
};

export default StatusCard;
